import { useState } from 'react';
import OsViewWeights from '../../components/OsNewWeight/OsViewWeights';
import OsCreateWeight from '../../components/OsNewWeight/OsCreateWeight';
import OsEditWeight from '../../components/OsNewWeight/OsEditWeight';
import OsUnitDetails from '../../components/OsNewWeight/OsUnitDetails';
import { IoAddCircleOutline } from 'react-icons/io5';
import { LuLayoutDashboard } from 'react-icons/lu';
import CardHeadeWithActions from '../../components/ui/CardHeadeWithActions';
import MwButton from './../../components/ui/MwButton';
import { useTranslation } from 'react-i18next';

const OSALLCAT = () => {
    const [mode, setMode] = useState('List');
    const [idSelected, setIdSelected] = useState();
 const [t,i18n ] = useTranslation('global')
  const isRTL = i18n.dir() === 'rtl';
    return (
        

        <>
     {mode === "List" && (
        <div className="mx-3">
          <CardHeadeWithActions
            title={
              <div className="flex items-center gap-2 text-xs">
                <LuLayoutDashboard size={18} />
                {t('Warehouse_settings.Unit List')}
              </div>
            }
          >
            <MwButton inGroup={true} type="saveBtn" onClick={() => setMode("Add")}>
              <IoAddCircleOutline />
              <span> {t('Warehouse_settings.Add Unit')}   </span>
            </MwButton>
          </CardHeadeWithActions>
        </div>
      )}

      {mode === "Details" && (
        <div className="mx-3">
          <CardHeadeWithActions
            title={
              <div className="flex items-center gap-2 text-xs">
                <LuLayoutDashboard size={18} />
                {/* {t('reports.Report_Settings')} */}
                {t('Warehouse_settings.Unit List')}
              </div>
            }
          >
            <MwButton inGroup={true} type="saveBtn" onClick={() => setMode("List")}>
               <span>{t('Warehouse_settings.Unit Settings')}</span>
            </MwButton>
          </CardHeadeWithActions>
        </div>
      )}
      {mode === "Add" && (
        <div className="mx-3">
          <CardHeadeWithActions
            title={
              <div className="flex items-center gap-2 text-xs">
                <LuLayoutDashboard size={18} />
                {/* {t('reports.Report_Settings')} */}
                {t('Warehouse_settings.Unit List')}
              </div>
            }
          >
            <MwButton inGroup={true} type="saveBtn" onClick={() => setMode("List")}>
               <span>   {t('Warehouse_settings.Unit_List')}</span>
            </MwButton>
          </CardHeadeWithActions>
        </div>
      )}
      {mode === "Edit" && (
        <div className="mx-3">
          <CardHeadeWithActions
            title={
              <div className="flex items-center gap-2 text-xs">
                <LuLayoutDashboard size={18} />
                {/* {t('reports.Report_Settings')} */}
                {t('Warehouse_settings.Unit List')}
              </div>
            }
          >
            <MwButton inGroup={true} type="saveBtn" onClick={() => setMode("List")}>
               <span>   {t('Warehouse_settings.Unit_List')}</span>
            </MwButton>
          </CardHeadeWithActions>
        </div>
      )}

  

 

        
            <div className="p-3">
                {mode === 'List' && <OsViewWeights idSelected={idSelected} setIdSelected={setIdSelected} setMode={setMode} />}
                {mode === 'Add' && <OsCreateWeight setMode={setMode} />}
                {mode === 'Edit' && idSelected && <OsEditWeight id={idSelected} setMode={setMode} />}
                {mode === 'Details' && idSelected && <OsUnitDetails id={idSelected} setMode={setMode} />}
            </div>
        </>
    );
}

export default OSALLCAT;